import Grid from "@material-ui/core/Grid";
import React, {FunctionComponent, useContext, useEffect, useMemo, useState, Fragment, useRef} from 'react';
import _ from 'lodash'

import './PhotoRoute.css';
import {IPathFinderData} from '../../../../../types/IPathFinder';
import ReactMarkdown from "react-markdown";
import {Context} from "../../../../../store/context";
import {observer} from "mobx-react";
import { usePictureAnalyticsObservers } from "../../../../../store/AnalyticsStore";

interface IPhotoRoute {
    photoData: IPathFinderData;
    positionNumber?: number
}

const PhotoRoute: FunctionComponent<IPhotoRoute> = ({photoData, positionNumber}) => {
    const {languagesStore} = useContext(Context);
    const [imgLoader, setImgLoader] = useState<boolean>(true);
    const [imgError, setImgError] = useState<boolean>(false);
    const ref = useRef<HTMLDivElement | null>(null);
    usePictureAnalyticsObservers(ref, { positionNumber, ...photoData });

    const hoverIconClass = useMemo(()=>{
        if(!photoData?.icon)
            return '';

        const regex = /([^/]+)(?=\.\w+$)/
        const name = _.first(photoData.icon.match(regex))

        if (_.isEmpty(name))
            return '';

        return _.isInteger(parseInt(name as any, 10))
            ? `pathfinder-${name}deg pathfinder-deg`
            : `pathfinder-${name} pathfinder-icon`;
    }, [photoData.icon]);
    const advertisementText = useMemo(()=>{
        if(!photoData.advertisementI18n)
            return undefined;

        const ad = photoData.advertisementI18n.find(ad => ad.languageIETF === languagesStore.currentIETF);
        if(!ad || !ad.text)
            return undefined;

        return ad.text.trim();
    }, [photoData.advertisementI18n, languagesStore.currentIETF]);


    const onImgLoad = (error: boolean = false) => {
        setImgLoader(false);
        error && setImgError(true);
    };

    return (
        <div ref={ref} className="photo-route col-xs-12 col-sm-6 col-md-3">
            <div className="photo-route__aspect-ratio">
                <div className={`photo-route__backdrop ${hoverIconClass}`}>
                    {advertisementText && <ReactMarkdown className="photo-route__advertisement" source={advertisementText}/> }
                    {positionNumber && <span className="photo-route__number bg-primary">{positionNumber}</span>}
                    {!imgError && <img className="photo-route__image with-spinner"
                         src={photoData.photo}
                         alt={photoData.photo}
                         onLoad={() => onImgLoad()}
                         onError={()=>onImgLoad(true)}/>}
                    {imgError && <span className="photo-route__img-not-found">No image found</span>}
                    {imgLoader && <i className="icon-spinner2 spinner loading"/>}
                </div>
            </div>
            <p className="photo-route__description">
                {photoData.instruction}
                {photoData.secondaryInstruction && <Fragment><br/>{photoData.secondaryInstruction}</Fragment>}
            </p>
        </div>
    )
};

export default observer(PhotoRoute);
